<app-breadcrumb></app-breadcrumb>

<div class="search-page-wrapper container-fluid">

  <div class="search-wrapper">

    <form [formGroup]="form" (ngSubmit)="handleSubmit($event)">

      <div class="input-wrapper">

        <div class="input-group">
          <span class="input-group-text">
            @if(loading()){
            <div class="spinner-border text-primary mx-auto" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            }@else {
            <i class="bi bi-search"></i>
            }
          </span>
          <input type="text" class="form-control" placeholder="Type to search" formControlName="search">

          @if(form.value.search){
          <button class="btn btn-outline-secondary clear" type="button" (click)="handleReset()">
            <i class="bi bi-x"></i>
          </button>
          }
        </div>

        @if(!authService.user?.isUserNoStore && !authService.user?.isUserBp){
        <button class="btn btn-outline strap-btn" type="button" (click)="handleSearchStraps()">
          <img src="assets/icons/strap.svg" alt="search strap">
          {{"Search Straps" | translate}}
        </button>
        }

      </div>

      @if(hint()){
      <div class="hint">
        {{"search_hint"|translate:{hint: hint()?.text} }}
      </div>
      }

    </form>

    <div class="suggestions">
      @for (suggestion of suggestions(); track suggestion) {
      <div class="suggestion">
        <button class="btn search" type="button" (click)="selectSuggestion(suggestion)">
          <i class="bi bi-search"></i>
          <span>{{suggestion.text}}</span>
        </button>
        <button class="btn btn-outline-primary clear btn-rounded" type="button"
          (click)="handleRemoveSuggestion(suggestion.text)">
          <i class="bi bi-x"></i>
        </button>
      </div>
      }
    </div>

  </div>

  <div class="products-wrapper">

    @if(products().length > 0) {
    <div class="products">

      @for (product of products(); track product) {
      <app-product [product]="product" [overrideCallback]="(handleProductClick).bind(this)" [newIn]="true"
        [isInSearchPage]="true"></app-product>
      }

    </div>
    }@else {

    <app-placeholder [message]="'Need Help?'|translate" [noStarImage]="true">
      <div class="message">
        {{ 'You can search a product using its name, SAP Code or Cat Code' | translate }}
      </div>
    </app-placeholder>

    }

  </div>

  <app-modal #modal class="strap-modal">
    <span title>
      {{"Strap Search"|translate}}
    </span>
    <form body class="strap-search" [formGroup]="strapsForm" (ngSubmit)="searchStraps()">
      <label class="form-label" for="searchStrapInput">
        {{"Enter the strap SAP code to discover more details." | translate}}
      </label>
      <div class="input-group">
        <input #input id="searchStrapInput" type="number" class="form-control" formControlName="search">
      </div>
      @if(errorMessage()){
      <div class="invalid-feedback" style="display: block;">
        {{errorMessage()}}
      </div>
      }
    </form>
    <div footer class="footer">
      <button class="btn btn-primary search-btn" (click)="searchStraps()" [disabled]="disabledSearch">
        {{"Search"|translate}}
        @if(loading()){
        <div class="spinner-border text-light mx-auto" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        }
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        {{"Close"|translate}}
      </button>
    </div>
  </app-modal>

  <app-straps-modal #strapsModal (onBuildEnd)="handleStrapsModalBuildEnd($event)"></app-straps-modal>
